// 所有跟语言相关的代码
import Vue from 'vue'
// 引入i18n核心包
import VueI18n from 'vue-i18n'

// 引入自定义语言包
import selfEN from './lang/en'
import selfZH from './lang/zh'

// 插件注册
Vue.use(VueI18n)

// 导出实例

const i18n = new VueI18n({
  // zh -> 中文  en -> 因为
  // 指定当前的默认的语言环境
  locale: "en",
  messages: {
    // 英文环境下的语言数据
    en: {
      ...selfEN
    },
    // 中文环境下的语言数据
    zh: {
      ...selfZH
    }
  }
})

export default i18n

